<template>
	<JFlex
		class="s-flex-col s-items-center s-bg-white s-border s-border-gray-200 s-rounded-lg"
		:class="[isCustomCss ? 's-h-64 ' : 's-shadow-sm hover:s-shadow-md s-transition-shadow s-duration-200 s-ease-in-out']"
	>
		<JFlex class="s-w-full s-py-2 s-items-center">
			<JFlex class="s-w-full s-items-center">
				<!-- Left: Preview of customized property -->
				<JBox class="s-w-3/12">
					<JLabel
						v-if="selectedProperty === 'colors'"
						class="s-w-10 s-h-10 s-mx-auto s-border s-border-gray-400 s-rounded-full s-cursor-pointer"
						:style="`background-color: ${this.propertyValue}`"
					>
						<input class="s-invisible" type="color" v-model="propertyValue"
					/></JLabel>

					<JBox
						v-if="selectedProperty === 'shadows'"
						class="s-w-8 s-h-8 s-mx-auto s-border-2 s-border-gray-500 "
						:style="`box-shadow: ${this.propertyValue}`"
					/>

					<JBox
						v-if="selectedProperty === 'typeFaces'"
						class="s-w-5 s-h-full s-mx-auto s-text-3xl s-font-medium"
						:style="`font-family: ${this.propertyValue}`"
					>
						T
					</JBox>
					<JBox v-if="isCustomCss" class="s-w-8 s-h-8 s-mx-auto">
						<svg fill="currentColor" viewBox="0 0 20 20">
							<path
								fill-rule="evenodd"
								d="M12.316 3.051a1 1 0 01.633 1.265l-4 12a1 1 0 11-1.898-.632l4-12a1 1 0 011.265-.633zM5.707 6.293a1 1 0 010 1.414L3.414 10l2.293 2.293a1 1 0 11-1.414 1.414l-3-3a1 1 0 010-1.414l3-3a1 1 0 011.414 0zm8.586 0a1 1 0 011.414 0l3 3a1 1 0 010 1.414l-3 3a1 1 0 11-1.414-1.414L16.586 10l-2.293-2.293a1 1 0 010-1.414z"
								clip-rule="evenodd"
							></path>
						</svg>
					</JBox>
				</JBox>

				<!-- Center: Slot name & config section -->
				<JFlex class="s-w-full s-h-full s-items-center s-justify-around s-pl-4">
					<!-- Slot name -->
					<JBox class="s-w-6/12 s-my s-mx-4" v-if="!isCustomCss">
						<JInputText
							ref="propertyName"
							class="s-text-lg s-font-semibold s-text-gray-600"
							v-model="propertyName"
							v-if="onFocus === 'propertyName'"
							@blur="blurInput()"
							@keyup.enter="blurInput()"
						/>
						<JText class="s-text-lg s-font-semibold s-text-gray-600" v-else @click="focusInput('propertyName')">
							{{ propertyName }}
						</JText>
					</JBox>

					<!-- Slot config -->
					<JBox class="s-w-full s-h-12 s-mr-4 s-mt-2">
						<JInputLongText :rows="8" v-model="propertyValue" v-if="isCustomCss" />
						<JInputText v-model="propertyValue" v-else />
					</JBox>
					<JBox class="s-w-full s-h-12 s-mr-4 s-mt-2" v-if="selectedProperty === 'typeFaces'">
						<JInputText v-model="updatedProperty.url" />
					</JBox>
				</JFlex>
			</JFlex>

			<!-- Right: Movable icon -->
			<JBox class="s-w-2/12 s-h-12 s-border-l-2 s-border-gray-100 cursor-move" v-if="!isCustomCss">
				<svg fill="gray" viewBox="-30 -8 80 80">
					<path
						fill-rule="evenodd"
						d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
						clip-rule="evenodd"
					></path>
				</svg>
			</JBox>
		</JFlex>
	</JFlex>
</template>
<script>
export default {
	data() {
		return {
			// Input field would be blured if JInputText's 'v-model' links to `updatedProperty.name`
			propertyName: "",
			// Type error if JInputLongText 'v-model' links to `updatedProperty`, when CustomCSS is loaded in it on mount.
			propertyValue: "",
			updatedProperty: {},
			onFocus: ""
		}
	},

	props: {
		property: {
			type: [Object, String],
			default: () => {}
		},
		selectedProperty: {
			type: String,
			default: ""
		}
	},

	mounted() {
		this.propertyName = this.isCustomCss ? "" : this.property.name
		this.propertyValue = this.isCustomCss ? this.property : this.property.value
		this.updatedProperty = this.property
	},

	computed: {
		isCustomCss() {
			return this.selectedProperty === "customCss"
		}
	},

	watch: {
		propertyValue() {
			this.isCustomCss ? (this.updatedProperty = this.propertyValue) : (this.updatedProperty.value = this.propertyValue)
		},

		updatedProperty: {
			handler() {
				this.$emit("propertyChanged", this.updatedProperty)
			},
			deep: true
		}
	},

	methods: {
		// Focus on input field once JText is clicked
		focusInput(refName) {
			this.onFocus = refName
			this.$nextTick(() => {
				this.$refs[`${refName}`].$el.focus()
			})
		},

		// Update changes to parents @blur
		blurInput() {
			this.onFocus = ""
			this.updatedProperty.name = this.propertyName
			this.$emit("propertyChanged", this.updatedProperty)
		}
	}
}
</script>
